import { lte, gt, multiply, subtract, divide } from "@/utils/helpers.js";

import _MixinBulk from "./MixinBulk";
export default class InlandBulk extends _MixinBulk {
  constructor(props) {
    super(props);

    this._adultNum = 0; // 成人数量
    this._adultBedNum = 0; // 成人加床

    this._childNum = 0; // 儿童数量
    this._childBedNum = 0; // 儿童加床
    this._maxChildBedNum = 0; // 最大儿童加床数量
    this._roomNum = 0; // 房间数
    this._maxRoomNum = 1; // 最大可选房间数
    this._maxChildNum = 0; // 最大儿童数量

    // this._roomNumStep = props.is_share !== 1 ? props.min_people === this.max_people ? 1 : 0.5 : 0.5;
    this._roomNumStep = props.is_share !== 1 ? 1 : 0.5;
    // 是否有单房差
    this.hasDiffRoomPrice = !!props.prices.sale.diff_room_price;

    // 能否拼房
    this.canShareRoom = props.is_share == 1;

    this._totalRoomBedNum = 0;
  }
  // 能否拼房
  // get canShareRoom(){
  //   return this.is_share === 1;
  // }
  // 最优入住房间数。
  getBestRoomNums() {
    let { _adultNum = 0, best_adult = 1, min_people } = this;
    let minPeople = Math.max(best_adult, min_people); // 最小人数 = min(最优入住人数, 最小入住人数)
    let roomNum = divide(_adultNum, minPeople); // 房间数
    let intNum = Math.floor(roomNum); // 房间整数部分
    let floatNum = subtract(roomNum, intNum); // 房间小数部分
    // (0 < 小数部分 <= 0.5) 并且 可拼房
    if (floatNum > 0) {
      if (lte(floatNum, 0.5) && this.canShareRoom) {
        floatNum = 0.5;
      } else {
        floatNum = 1;
      }
    }
    return intNum + floatNum;
  }
  getMaxRoomNum() {
    let maxRoomNum;
    let adultNum = this._adultNum;
    let bestRoomNum = this.getBestRoomNums();
    let min_people = this.hasDiffRoomPrice
      ? this.min_people - 1
      : this.min_people;
    min_people = min_people <= 0 ? 1 : min_people;

    if (this.canShareRoom) {
      if (this.hasDiffRoomPrice) {
        maxRoomNum = Math.ceil(adultNum / min_people);
      } else {
        maxRoomNum = bestRoomNum;
      }
    } else {
      maxRoomNum = Math.ceil(adultNum / min_people);
    }
    return maxRoomNum;
  }
  // 房间数增加 步长
  get roomNumStep() {
    return this._roomNumStep;
  }

  set adultNum(adultNum) {
    this._adultNum = adultNum;
    let bestRoomNum = this.getBestRoomNums();
    // 可拼房 并且有单房差

    this._maxRoomNum = this.getMaxRoomNum();
    // console.log({bestRoomNum, maxRoomNum})

    if (bestRoomNum === 0.5) {
      this._roomNum = bestRoomNum;
      this._maxChildNum = 1;
    } else {
      this.roomNum = bestRoomNum;
    }
  }
  get adultNum() {
    return this._adultNum;
  }

  set childNum(val) {
    // if(this._adultNum <= 0){
    //   console.log({_adultNum: this._adultNum}, 'return')
    //   return;
    // }
    this._childNum = val;
    let bestRoomNum = this.getBestRoomNums();
    if (bestRoomNum == 0.5 && val <= 1) {
      if (val === 1) {
        this._maxRoomNum = 1;
        this._roomNum = 1;
      } else {
        this._roomNum = bestRoomNum;
        this._maxRoomNum = this.getMaxRoomNum();
      }

      return;
    }

    // let _roomNum = this.getBestRoomNums();
    // if(_roomNum == 0.5){
    // }else{
    //   this._roomNum = this.getBestRoomNums();
    // }
    let maxChildBedNum;
    let { _adultNum = 0, _adultBedNum = 0 } = this;
    let totalPeopleNum = val + _adultNum; // 总人数
    let intRoomNum = Math.floor(this._roomNum);
    let bestPeopleNum = multiply(this.best_adult, this._roomNum); // 最优入住人数

    // 总人数 大于 最优入住人数
    if (gt(totalPeopleNum, bestPeopleNum)) {
      // 儿童最大加床数 = 总人数 - 最优入住人数 - 成人加床数
      maxChildBedNum = totalPeopleNum - bestPeopleNum - _adultBedNum;

      // 房间数为小数 最大儿童加床数 - 1
      if (intRoomNum !== this._roomNum) {
        maxChildBedNum -= 1;
      }

      // 最大加床数 不能超过 儿童数量
      maxChildBedNum = Math.min(maxChildBedNum, val);
    } else {
      maxChildBedNum = 0;
    }

    // 最大儿童加床数 min( 最大儿童加床数, 成人加床数 > 0 ? 房间整数 - 成人加床数 : 房间整数)
    maxChildBedNum = Math.min(
      maxChildBedNum,
      this._adultBedNum > 0 ? subtract(intRoomNum, _adultBedNum) : intRoomNum
    );
    // console.log({ maxChildBedNum });
    // 最大儿童加床数
    this._maxChildBedNum = maxChildBedNum;
    // 儿童加床数
    this.childBedNum = Math.min(maxChildBedNum, this.childBedNum);

    this.validate();
  }
  // 儿童数·
  get childNum() {
    return this._childNum;
  }

  // 成人数量 % (房间数量 * 房间最小入住人数)
  get adultBedNum() {
    return this._adultBedNum;
  }

  // 儿童不占床数量 = 儿童数量 - 儿童加床床数量
  get childNotBedNum() {
    if (this.childNum <= 0 || !this.canChildNoBed) {
      return 0;
    }
    // let leftBedNum = this.adultBedNum ? 0 : subtract(this._totalRoomBedNum, this.adultNum);
    let totalPeople = this.adultNum + this.childNum;
    return gt(totalPeople, this._totalRoomBedNum)
      ? [this._totalRoomBedNum, this.adultBedNum, this._childBedNum].reduce(
          subtract,
          totalPeople
        )
      : 0;
  }
  // 儿童数量
  get childBedNum() {
    return this._childBedNum;
  }
  // 儿童加床数量
  set childBedNum(val) {
    this._childBedNum = Math.max(val, 0);
  }
  // 能否儿童加床
  get canChildAddBed() {
    let totalPeopleNums = this._childNum + this._adultNum;
    return (
      gt(totalPeopleNums, this._totalRoomBedNum) &&
      this.childNum && // 儿童数存在
      gt(this.prices.th.child_bed_price, 0) &&
      this._maxChildBedNum
    ); // 儿童加床价格 大于0
  }

  // 房间数量
  get roomNum() {
    return this._roomNum;
  }
  // 房间数量 set
  set roomNum(val) {
    if (val <= 0) {
      this._roomNum = 0;
      this._totalRoomBedNum = 0;
      this._adultBedNum = 0;
      this._maxChildBedNum = 0;
      this.childBedNum = 0;
      this._childNum = 0;
      this._maxChildNum = 0;
      this.validate();
      return;
    }
    if (val < 1) {
      this._roomNum = val;
      this._totalRoomBedNum = 0;
      this._adultBedNum = 0;
      this._maxChildBedNum = 0;
      this.childBedNum = 0;
      this._childNum = 0;
      this._maxChildNum = 1;
      this.validate();
      return;
    }

    // 可入住总人数
    // let canInPepple = multiply(val, this.max_people);
    let intRoomNum = Math.floor(val);
    let hasBeds = multiply(val, this.min_people);

    // 最大儿童数 = 总人数 - 成人数
    let maxChildNum;
    if (intRoomNum === val) {
      maxChildNum = subtract(multiply(val, this.max_people), this._adultNum);
    } else {
      maxChildNum = subtract(
        multiply(intRoomNum, this.max_people),
        this._adultNum - 1
      );
    }
    this._maxChildNum = maxChildNum;
    // let maxChildNum = this._maxChildNum =  ?   : ;

    // console.log(maxChildNum, "maxChildNum");
    // 最大儿童数 和 儿童数取最小值
    let childNum = (this.childNum = Math.min(this._childNum, maxChildNum));
    // 剩余床位数
    let remainBeds = [childNum, this.adultNum].reduce(subtract, hasBeds);

    //gt(this.adultNum, this._totalRoomBedNum) ? this.adultNum % this._totalRoomBedNum : 0
    // 闲置床数大于0
    if (remainBeds > 0) {
      this._adultBedNum = 0; // 成人加床归0
      this._maxChildBedNum = 0; // 儿童最大加床数  0
      this.childBedNum = 0; // 儿童加床数 0
      // console.log(this.childBedNum, "childBedNum");
    } else {
      let adultBedNum = 0;
      // console.log(this);
      // console.log(this.adultNum , this.hasBeds, "remainBeds");

      adultBedNum = this._adultNum - val * this.best_adult;
      adultBedNum = adultBedNum < 0 ? 0 : adultBedNum;
      let maxChildBedNum = subtract(intRoomNum, adultBedNum);
      // console.log(intRoomNum, adultBedNum, "maxChildBedNum");

      this._adultBedNum = adultBedNum;
      this._maxBedNum = maxChildBedNum;
      // let maxBedNum =
      this.childBedNum =
        remainBeds >= 0 ? 0 : Math.min(maxChildNum, this.childBedNum);
    }

    this._roomNum = val;
    this._totalRoomBedNum = hasBeds;

    this.validate();
  }

  /**
   * @desc 最小入住房间数
   * 入住人数/最大入住人数 不足0.5取0.5，0.5整就保留0.5拼房，超过0.5就取1
   *  例，2-4维护了成人加床入住
   * 入住1人 最大：1/1=1 最小：1/2=0.5
   * 入住3人 最大：3/1=3 最小：3/3=1
   * 入住5人 最大：5/1=5 最小：5/3=1.6666=2（按照规则超过0.5取1）
   * 入住7人 最大：7/1=7 最小：7/3=2.3333=2.5（按照规则不足0.5取0.5）
   */
  get minRoomNum() {
    // let maxAdultNum = this.
    // console.log("minRoomNum", this._adultNum / this.max_adult);
    return this._adultNum / this.max_adult;
  }
  get maxRoomNum() {
    return this._maxRoomNum;
  }
  // 单房差
  get diffRoomPriceNum() {
    if (!this.hasDiffRoomPrice) {
      return 0;
    }
    if (!this.validResult.valid) {
      return 0;
    }

    let nums = [this.adultNum, this.childNum].reduce(
      subtract,
      this._totalRoomBedNum
    ); //  this._totalRoomBedNum - this.adultNum -this.childNum; // sum();
    return nums > 0 ? nums : 0;
  }
}
